// Auto-generated registry — maps page key → renderer.
import { renderDashboard } from './dashboard';
import { renderSpendAnalysis } from './spendAnalysis';
import { renderSpendDistribution } from './spendDistribution';
import { renderCategoryConsole } from './categoryConsole';
import { renderCommonality } from './commonality';
import { renderComparative } from './comparative';
import { renderP2P } from './p2p';
import { renderBenchmark } from './benchmark';
import { renderDataQuality } from './dataQuality';
import { renderSupplierDirectory } from './supplierDirectory';
import { renderSuppliers } from './suppliers';
import { renderForecasting } from './forecasting';
import { renderGovernance } from './governance';

export const PAGE_RENDERERS = {
  'dashboard': renderDashboard,
  'spend-analysis': renderSpendAnalysis,
  'spend-distribution': renderSpendDistribution,
  'category-console': renderCategoryConsole,
  'commonality': renderCommonality,
  'comparative': renderComparative,
  'p2p-analytics': renderP2P,
  'industry-benchmark': renderBenchmark,
  'data-quality': renderDataQuality,
  'supplier-directory': renderSupplierDirectory,
  'suppliers': renderSuppliers,
  'forecasting': renderForecasting,
  'governance': renderGovernance,
};
